import { type FC } from 'react';
import {
  faArrowUpRightAndArrowDownLeftFromCenter,
  faClone,
  faXmarkLarge,
} from '@fortawesome/pro-light-svg-icons';
import type { VolSurfaceTimeseriesProps } from './types';
import VolSurfaceTimeseriesContent from './vol-surface-timeseries-content';
import { Widget } from '../../widget';

const VolSurfaceTimeseriesWidget: FC<VolSurfaceTimeseriesProps & { onlyPerps?: boolean }> = (
  props,
) => {
  const { widget, actions, onlyPerps } = props;

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.Buttons>
          <Widget.Button
            icon={faArrowUpRightAndArrowDownLeftFromCenter}
            onClick={() => actions.handleMaximizeWidget(widget.id || widget.key)}
          />
          <Widget.Button
            icon={faClone}
            onClick={() => actions.handleDuplicateWidget(widget.id || widget.key)}
          />
          <Widget.Button
            icon={faXmarkLarge}
            onClick={() => actions.handleCloseWidget(widget.id || widget.key)}
          />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <VolSurfaceTimeseriesContent onlyPerps={onlyPerps} />
      </Widget.Content>
      <Widget.Footer></Widget.Footer>
    </Widget>
  );
};

export default VolSurfaceTimeseriesWidget;
